import { Route, Routes } from 'react-router-dom'

import NavigateToError from '@/features/error/pages/NavigateToError'
import ResourceSwitchboardIndex from '@/features/resourceSwitchboard/pages/ResourceSwitchboardIndex'

export default function ResourceSwitchboardRoutes() {
  return (
    <Routes>
      <Route element={<ResourceSwitchboardIndex />} path="/" />
      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </Routes>
  )
}
